
import React from 'react';
import { PageTitle, Card, Button } from '../components/common';

const SettingsPage: React.FC = () => {
    return (
        <div>
            <PageTitle title="Settings" subtitle="Manage your account settings and preferences." />
            
            <div className="space-y-6">
                <Card className="p-6">
                    <h3 className="text-lg font-bold text-gray-800 border-b pb-4 mb-4">Account Settings</h3>
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Change Password</label>
                            <div className="mt-1 flex gap-2">
                                <input type="password" placeholder="Current Password" className="flex-1 p-2 border border-gray-300 rounded-md" />
                                <input type="password" placeholder="New Password" className="flex-1 p-2 border border-gray-300 rounded-md" />
                                <Button>Update</Button>
                            </div>
                        </div>
                    </div>
                </Card>
                
                <Card className="p-6">
                    <h3 className="text-lg font-bold text-gray-800 border-b pb-4 mb-4">Notification Settings</h3>
                    <div className="space-y-4">
                        <div className="flex justify-between items-center">
                            <p className="text-sm font-medium text-gray-700">Email Notifications</p>
                            <label className="relative inline-flex items-center cursor-pointer">
                                <input type="checkbox" value="" className="sr-only peer" defaultChecked />
                                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-red-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
                            </label>
                        </div>
                         <div className="flex justify-between items-center">
                            <p className="text-sm font-medium text-gray-700">Push Notifications</p>
                            <label className="relative inline-flex items-center cursor-pointer">
                                <input type="checkbox" value="" className="sr-only peer" />
                                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-red-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
                            </label>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default SettingsPage;
